<template>
	<div id="Main">
		<setpbox :type="2"></setpbox>
		<div class="htitle">
			<p class="p1">我的信息</p>
			<p class="p2">请检查上传信息是否正确</p>
		</div>
		<div class="box">
			<div class="inputbox">
				<span class="label">
					<van-icon class="icon" :name="require('../../assets/images/service/account_1.png')" />股东代码：</span>
				<van-field class="input" :value="formdata.shareholdeCode" readonly />
			</div>
			<div class="inputbox">
				<span class="label">
					<van-icon class="icon" :name="require('../../assets/images/service/user_1.png')" />股东姓名：</span>
				<van-field class="input" :value="formdata.shareholdeName" readonly />
			</div>
		</div>
		<p class="name" v-if="formdata.bussinessType==2">股权过出信息</p>
		<p class="name" v-if="formdata.bussinessType==3">股权过入信息</p>
		<p class="name" v-if="formdata.bussinessType==4">股权质押信息</p>
		<p class="name" v-if="formdata.bussinessType==5">股权解除质押信息</p>
		<div class="box">
			<div class="form">
				<div class="inputbox">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/account_1.png')" />
						<span>企业代码</span><span v-if="formdata.bussinessType==3" class="ico">*</span>
					</div>
					<van-field class="input" :value="formdata.companyCode" readonly type="text"/>
				</div>
				<div class="inputbox">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>企业简称</span><span v-if="formdata.bussinessType==3" class="ico">*</span>
					</div>
					<van-field class="input" readonly :value="formdata.companyShortName" type="text"/>
				</div>
				<div class="inputbox" v-if="formdata.bussinessType==2 || formdata.bussinessType==3">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过户数量</span><span class="ico">*</span>
					</div>
					<van-field class="input" readonly :value="formdata.transferNum" type="text"/>
				</div>
				<div class="inputbox" v-if="formdata.bussinessType==2 || formdata.bussinessType==3">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过户原因</span>
					</div>
					<van-field class="input" readonly :value="formdata.transferReason" type="text"/>
				</div>
				<div class="inputbox" v-if="formdata.bussinessType==3">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过出方姓名</span><span class="ico">*</span>
					</div>
					<van-field class="input" readonly :value="formdata.comeName" type="text"/>
				</div>
				<div class="inputbox" v-if="formdata.bussinessType==3">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过出方证件类型</span>
					</div>
					<van-field class="input" readonly :value="formdata.comeIdcardType" type="text"/>
				</div>
				<div class="inputbox" v-if="formdata.bussinessType==3">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过出方证件号码</span><span class="ico">*</span>
					</div>
					<van-field class="input" readonly :value="formdata.comeIdcard" type="text"/>
				</div>
				<div class="inputbox" v-if="formdata.bussinessType==3">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过出方账户号</span>
					</div>
					<van-field class="input" readonly :value="formdata.comeUsername" type="text"/>
				</div>
			
				<div class="inputbox" v-if="formdata.bussinessType==2">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过入方姓名</span><span class="ico">*</span>
					</div>
					<van-field class="input" readonly :value="formdata.toName" type="text"/>
				</div>
				<div class="inputbox" v-if="formdata.bussinessType==2">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过入方证件类型</span>
					</div>
					<van-field class="input" readonly :value="formdata.toIdcardType" type="text"/>
				</div>
				<div class="inputbox" v-if="formdata.bussinessType==2">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过入方证件号码</span><span class="ico">*</span>
					</div>
					<van-field class="input" readonly :value="formdata.toIdcard" type="text"/>
				</div>
				<div class="inputbox" v-if="formdata.bussinessType==2">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>过入方账户号</span>
					</div>
					<van-field class="input" readonly :value="formdata.toUsername" type="text"/>
				</div>
				<div class="inputbox" v-if="formdata.bussinessType==4">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>质押数量</span>
					</div>
					<van-field class="input" readonly :value="formdata.pledgeNum" type="text"/>
				</div>
				<div class="inputbox" v-if="formdata.bussinessType==5">
					<div class="title">
						<van-icon class="icon" :name="require('../../assets/images/service/codeicon_1.png')" />
						<span>解除质押数量</span>
					</div>
					<van-field class="input" readonly :value="formdata.relievePledgeNum" type="text"/>
				</div>
			</div>
		</div>
		<div class="htitle">
			<p class="p1">上传的资料</p>
		</div>
		<van-row type="flex" class="loaderbox">
			<van-col class="loaderimg" v-for="(item,index) in img" :key="index">
				<div class="pos">
					<van-image width="100%" height="100%" fit="contain" :src="item.filePath" />
				</div>
			</van-col>
		</van-row>
		<van-button round type="info" v-if="intercept" class="submit" @click="submit">申请</van-button>
	</div>
</template>
<script>
	import axiosPost from '../../libs/moudle/index.js';
	import setpbox from '../../components/setboxshen';
	export default {
		components: {
			setpbox
		},
		data() {
			return {
				formdata:'', /*, 表单数据 */
				loading:true,
				img:[],
				type:'',
				intercept:true
			}
		},
		methods: {
			submit() {
				// let t=this;
				this.intercept=false
				this.$toast.loading({
					message: '处理中...',
					forbidClick: true,
					duration: 0
				});
				let formdata=this.formdata;
				let img=[];
				this.img.forEach((item)=>{
					img.push(item.savePath)
				})
				formdata.img=img.join(',')
				axiosPost.addsave(formdata).then((res) => {
					this.$toast.clear();
					if (res.data.code == 200) {
						this.$toast({duration:4000,message:'申请成功！'});
						let txt='';
						if(formdata.bussinessType==1){
							txt='红利领取申请成功！'
							this.Journal('红利领取')
						}else if(formdata.bussinessType==2){
							txt='股权过出申请成功！'
							this.Journal('股权过出')
						}else if(formdata.bussinessType==3){
							txt='股权过入申请成功！'
							this.Journal('股权过入')
						}else if(formdata.bussinessType==4){
							txt='股权质押申请成功！'
							this.Journal('股权质押')
						}else if(formdata.bussinessType==5){
							txt='股权解除质押申请成功！'
							this.Journal('股权解除质押')
						}
						this.$router.push({
							path: '/msghtml',
							query: {
								text:txt
							}
						})
					} else {
						this.intercept=true
						// t.$toast({duration:4000,message:'系统错误，请稍后再试！'});
					}
				}).catch((res) => {
					this.intercept=true
					window.console.log(res)
				})
			},
			Journal(text){/* 用户日志 */
				let nowData = new Date()
				let month = nowData.getMonth() + 1;
				let strDate = nowData.getDate();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				let hour = nowData.getHours();//得到小时
				let minu = nowData.getMinutes();//得到分钟
				let sec = nowData.getSeconds();//得到秒
				let time = nowData.getFullYear()+ '-' + month + '-' + strDate + ' ' + hour + ':' +minu + ':' + sec
				axiosPost.Journal({
					type:text,
					title:this.formdata.shareholdeName+'提交了'+text,
					details:this.formdata.shareholdeName+'提交了'+text,
					userId: this.formdata.shareholdeCode,
					userName:this.formdata.shareholdeName,
					logDate:time,/* 时间 */
				}).then((res) => {
					window.console.log(res)
				}).catch((res) => {
					window.console.log(res)
				})
			},
		},
		mounted() {
			if(!localStorage.getItem('formdata')){
				this.$router.go(-1)
			}
			this.formdata = JSON.parse(localStorage.getItem('formdata')); /* 获取缓存表单数据 */
			localStorage.removeItem("formdata");
			this.img=this.formdata.img;
		},
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		min-height: 100vh;
		background-color: #f2f9ff;

		.loaderbox {
			width: 100%;
			flex-wrap: wrap;
			margin: 1.5rem 0;
			.loaderimg {
				width: 30%;
				padding: 15% 0;
				margin-right: 5%;
				position: relative;
				margin-bottom: 1.5rem;
				.pos {
					position: absolute;
					top: 0;
					left: 0;
					bottom: 0;
					right: 0;
				}

				&:nth-child(3n) {
					margin-right: 0;
				}
			}
		}

		.htitle {
			margin-bottom: 1rem;
			padding-top: 1rem;
			text-align: left;

			.p1 {
				font-weight: bold;
				color: #161616;
				font-size: 1.8rem;
				line-height: 2.5rem;
			}

			.p2 {
				color: #999999;
				font-size: 1.4rem;
				line-height: 2rem;
			}
		}

		.submit {
			width: 90%;
			display: block;
			margin: 2rem auto;
			background-color: #fa6b6b;
			border: 0;
			box-shadow: 0 3px 8px 1px #e8eaee;
		}

		.form {
			padding-bottom: 3rem;

			.inputbox {
				padding: 1rem 0;
				padding-left: 3rem;

				.input {
					flex: 1;
					padding: 0;
					height: 4rem;
					line-height: 4rem;
					border-bottom: 1px solid #e0dfdf;

					&:not(:last-child):after {
						display: none;
					}
				}

				.select {
					color: #a0a0a0;
				}
			}

			.title {
				text-align: left;
				line-height: 2.5rem;
				margin-left: -2.3rem;

				span {
					font-weight: bold;
					font-size: 1.6rem;
					color: #333;
				}

				.ico {
					color: #fa6b6b;
					display: inline-block;
					margin-left: 5px;
				}

				.icon {
					vertical-align: -0.25rem;
					margin-right: 0.8rem;
				}
			}
		}

		.box {
			background-color: #fff;
			border-radius: 8px;
			padding: 0 1rem;
			margin-bottom: 1rem;
			box-shadow: 0 2px 5px 1px #e4ebfa;

			&>.inputbox {
				display: flex;
				margin-bottom: 0.8rem;
				margin-left: auto;
				margin-right: auto;
				border-bottom: 1px solid #ebebeb;
				padding: 1rem 0;
				line-height: 2.4rem;

				&:last-child {
					margin-bottom: 0;
					border-bottom: 0;
				}

				.input {
					padding: 0 1rem 0 0;
					flex: 1;
					line-height: 2.4rem;
					font-size: 1.6rem;
				}

				.label {
					color: #4f1c1c;
					font-size: 1.6rem;
					margin-right: 0.6rem;
				}

				.icon {
					vertical-align: -0.2rem;
					margin-right: 0.6rem;
				}

			}

			.warning {
				font-size: 1.4rem;
				color: #fa6b6b;
				text-align: left;
				margin-bottom: 1rem;
			}
		}
		
		.name {
			text-align: left;
			font-size: 1.8rem;
			color: #333;
			line-height: 3.5rem;
			padding: 0.6rem 0;
			font-weight: bold;
		}
	}
</style>
